export type BringgFontIconsId =
  | "accelerate"
  | "add-location-alt"
  | "ai"
  | "alt-route"
  | "analytics-chart"
  | "analytics"
  | "area-chart"
  | "arrow-down"
  | "arrow-left"
  | "arrow-right"
  | "arrow-up"
  | "arrow"
  | "arrows-up-down"
  | "attachment"
  | "auto-stories"
  | "autopay"
  | "barcode"
  | "bars-filter"
  | "battery-full"
  | "battery-ver-empty"
  | "battery-ver-half"
  | "battery-ver-quarter"
  | "battery-ver-three-quarters"
  | "bicycle"
  | "block"
  | "break-to"
  | "bringg"
  | "bullseye"
  | "bus"
  | "business"
  | "busket"
  | "cafe-solid"
  | "cafe"
  | "calendar"
  | "campaign"
  | "cancel"
  | "cancelled"
  | "capacity"
  | "car"
  | "cart"
  | "cashier"
  | "chat-bubble"
  | "chat-bubbles"
  | "checklist"
  | "chevron-left"
  | "chevron-right"
  | "chevron-up"
  | "chevron"
  | "chevrons-end"
  | "chevrons-start"
  | "circle-exclamation"
  | "circle-plus"
  | "circle"
  | "clock-light"
  | "clock"
  | "close-circle"
  | "close"
  | "coins"
  | "colorize"
  | "columns"
  | "compare"
  | "compass"
  | "completed"
  | "connected-hub"
  | "control-tower"
  | "copy"
  | "create-route-plus"
  | "create-route"
  | "credit-card"
  | "crew"
  | "csv-file"
  | "cube"
  | "customer-sdk"
  | "customer"
  | "cutoff"
  | "delivery-blocks"
  | "delivery-slots"
  | "deployed-code-history"
  | "design-services"
  | "dispatch"
  | "dispatchers"
  | "distance"
  | "distribution-hub"
  | "documenatation-link"
  | "document"
  | "done-planning"
  | "dot"
  | "download"
  | "drag"
  | "driver-home"
  | "drivers-returning-to-base"
  | "drivers"
  | "dropoff"
  | "eco"
  | "edit-square"
  | "erase"
  | "event-available"
  | "expenses"
  | "export"
  | "external-id"
  | "external-link"
  | "eye-off"
  | "eye"
  | "feather"
  | "file-alt"
  | "file-import"
  | "file"
  | "filter-hdr"
  | "filter-list"
  | "flat-tire"
  | "floating-inventory"
  | "fork-left-right-back"
  | "forward"
  | "fragile"
  | "freeze"
  | "functions"
  | "globe"
  | "go-to-link"
  | "graph-overview"
  | "graph"
  | "group-by"
  | "hamburger"
  | "hand-pan-move"
  | "hand-pointing-up"
  | "headset"
  | "heart-filled"
  | "heart"
  | "help"
  | "home"
  | "hourglass"
  | "hub"
  | "info-filled"
  | "info"
  | "inventory"
  | "json"
  | "keyboard"
  | "launch"
  | "layers-fill"
  | "layers"
  | "leaf-eco"
  | "library-books"
  | "link"
  | "list"
  | "loader"
  | "local-police"
  | "local-shipping"
  | "location-fill"
  | "location"
  | "lock"
  | "locker"
  | "logout"
  | "man"
  | "manage-history"
  | "map-task"
  | "map"
  | "maximize"
  | "menu-horizontal"
  | "menu"
  | "message-mail"
  | "minimize"
  | "minus"
  | "mobile-action-complete-form"
  | "mobile-action-question"
  | "monitor"
  | "move-to-dispatch"
  | "move-to-planning"
  | "my-location"
  | "navigation-up"
  | "navigation"
  | "no-location"
  | "no-vehicle"
  | "note-light"
  | "notes"
  | "notification"
  | "open-in-new"
  | "optimize"
  | "order"
  | "ordered-list"
  | "orders"
  | "package"
  | "pallets"
  | "parking-location"
  | "parking"
  | "partner-exchange"
  | "pause"
  | "pdf-file"
  | "pencil"
  | "phone-android"
  | "phone"
  | "pickup"
  | "planning"
  | "play"
  | "plus"
  | "power"
  | "preferences"
  | "preparation-restaurant"
  | "preperation"
  | "print"
  | "promped-message"
  | "puzzle"
  | "radar"
  | "recipt"
  | "redo-arrow"
  | "redo"
  | "reload"
  | "report"
  | "reschedule"
  | "resources"
  | "revenues"
  | "reviews"
  | "ro-simulator"
  | "rotate"
  | "route-identifier"
  | "route"
  | "ruler"
  | "satellite"
  | "save-as"
  | "save"
  | "scanner"
  | "search"
  | "selected-outline"
  | "selected"
  | "send"
  | "service-areas"
  | "settings-suggest"
  | "settings"
  | "share"
  | "sheet-with-dollar"
  | "shield-person"
  | "show-less"
  | "show-more"
  | "skills"
  | "small-circle"
  | "sort-asc"
  | "sort-desc"
  | "sparkles"
  | "star"
  | "sticky-note"
  | "stop-circle"
  | "store"
  | "suffix"
  | "suitcase"
  | "support"
  | "takeout-dining"
  | "task-alt"
  | "team-home"
  | "team-parking"
  | "team"
  | "text-bold"
  | "text-italic"
  | "text-underline"
  | "thumb-down"
  | "thumb-up"
  | "ticket"
  | "traffic"
  | "trailer"
  | "trash"
  | "tree"
  | "truck"
  | "unassign"
  | "unassigned"
  | "unavailable"
  | "undo-arrow"
  | "undo"
  | "unuser"
  | "upload"
  | "user-fill"
  | "user"
  | "users"
  | "verification-code"
  | "walking"
  | "warehouse-fill"
  | "warehouse"
  | "warning-circle-not-filled"
  | "warning-circle"
  | "warning-not-filled"
  | "warning"
  | "weight"
  | "wheel"
  | "zoom-in"
  | "zoom-out";

export type BringgFontIconsKey =
  | "Accelerate"
  | "AddLocationAlt"
  | "Ai"
  | "AltRoute"
  | "AnalyticsChart"
  | "Analytics"
  | "AreaChart"
  | "ArrowDown"
  | "ArrowLeft"
  | "ArrowRight"
  | "ArrowUp"
  | "Arrow"
  | "ArrowsUpDown"
  | "Attachment"
  | "AutoStories"
  | "Autopay"
  | "Barcode"
  | "BarsFilter"
  | "BatteryFull"
  | "BatteryVerEmpty"
  | "BatteryVerHalf"
  | "BatteryVerQuarter"
  | "BatteryVerThreeQuarters"
  | "Bicycle"
  | "Block"
  | "BreakTo"
  | "Bringg"
  | "Bullseye"
  | "Bus"
  | "Business"
  | "Busket"
  | "CafeSolid"
  | "Cafe"
  | "Calendar"
  | "Campaign"
  | "Cancel"
  | "Cancelled"
  | "Capacity"
  | "Car"
  | "Cart"
  | "Cashier"
  | "ChatBubble"
  | "ChatBubbles"
  | "Checklist"
  | "ChevronLeft"
  | "ChevronRight"
  | "ChevronUp"
  | "Chevron"
  | "ChevronsEnd"
  | "ChevronsStart"
  | "CircleExclamation"
  | "CirclePlus"
  | "Circle"
  | "ClockLight"
  | "Clock"
  | "CloseCircle"
  | "Close"
  | "Coins"
  | "Colorize"
  | "Columns"
  | "Compare"
  | "Compass"
  | "Completed"
  | "ConnectedHub"
  | "ControlTower"
  | "Copy"
  | "CreateRoutePlus"
  | "CreateRoute"
  | "CreditCard"
  | "Crew"
  | "CsvFile"
  | "Cube"
  | "CustomerSdk"
  | "Customer"
  | "Cutoff"
  | "DeliveryBlocks"
  | "DeliverySlots"
  | "DeployedCodeHistory"
  | "DesignServices"
  | "Dispatch"
  | "Dispatchers"
  | "Distance"
  | "DistributionHub"
  | "DocumenatationLink"
  | "Document"
  | "DonePlanning"
  | "Dot"
  | "Download"
  | "Drag"
  | "DriverHome"
  | "DriversReturningToBase"
  | "Drivers"
  | "Dropoff"
  | "Eco"
  | "EditSquare"
  | "Erase"
  | "EventAvailable"
  | "Expenses"
  | "Export"
  | "ExternalId"
  | "ExternalLink"
  | "EyeOff"
  | "Eye"
  | "Feather"
  | "FileAlt"
  | "FileImport"
  | "File"
  | "FilterHdr"
  | "FilterList"
  | "FlatTire"
  | "FloatingInventory"
  | "ForkLeftRightBack"
  | "Forward"
  | "Fragile"
  | "Freeze"
  | "Functions"
  | "Globe"
  | "GoToLink"
  | "GraphOverview"
  | "Graph"
  | "GroupBy"
  | "Hamburger"
  | "HandPanMove"
  | "HandPointingUp"
  | "Headset"
  | "HeartFilled"
  | "Heart"
  | "Help"
  | "Home"
  | "Hourglass"
  | "Hub"
  | "InfoFilled"
  | "Info"
  | "Inventory"
  | "Json"
  | "Keyboard"
  | "Launch"
  | "LayersFill"
  | "Layers"
  | "LeafEco"
  | "LibraryBooks"
  | "Link"
  | "List"
  | "Loader"
  | "LocalPolice"
  | "LocalShipping"
  | "LocationFill"
  | "Location"
  | "Lock"
  | "Locker"
  | "Logout"
  | "Man"
  | "ManageHistory"
  | "MapTask"
  | "Map"
  | "Maximize"
  | "MenuHorizontal"
  | "Menu"
  | "MessageMail"
  | "Minimize"
  | "Minus"
  | "MobileActionCompleteForm"
  | "MobileActionQuestion"
  | "Monitor"
  | "MoveToDispatch"
  | "MoveToPlanning"
  | "MyLocation"
  | "NavigationUp"
  | "Navigation"
  | "NoLocation"
  | "NoVehicle"
  | "NoteLight"
  | "Notes"
  | "Notification"
  | "OpenInNew"
  | "Optimize"
  | "Order"
  | "OrderedList"
  | "Orders"
  | "Package"
  | "Pallets"
  | "ParkingLocation"
  | "Parking"
  | "PartnerExchange"
  | "Pause"
  | "PdfFile"
  | "Pencil"
  | "PhoneAndroid"
  | "Phone"
  | "Pickup"
  | "Planning"
  | "Play"
  | "Plus"
  | "Power"
  | "Preferences"
  | "PreparationRestaurant"
  | "Preperation"
  | "Print"
  | "PrompedMessage"
  | "Puzzle"
  | "Radar"
  | "Recipt"
  | "RedoArrow"
  | "Redo"
  | "Reload"
  | "Report"
  | "Reschedule"
  | "Resources"
  | "Revenues"
  | "Reviews"
  | "RoSimulator"
  | "Rotate"
  | "RouteIdentifier"
  | "Route"
  | "Ruler"
  | "Satellite"
  | "SaveAs"
  | "Save"
  | "Scanner"
  | "Search"
  | "SelectedOutline"
  | "Selected"
  | "Send"
  | "ServiceAreas"
  | "SettingsSuggest"
  | "Settings"
  | "Share"
  | "SheetWithDollar"
  | "ShieldPerson"
  | "ShowLess"
  | "ShowMore"
  | "Skills"
  | "SmallCircle"
  | "SortAsc"
  | "SortDesc"
  | "Sparkles"
  | "Star"
  | "StickyNote"
  | "StopCircle"
  | "Store"
  | "Suffix"
  | "Suitcase"
  | "Support"
  | "TakeoutDining"
  | "TaskAlt"
  | "TeamHome"
  | "TeamParking"
  | "Team"
  | "TextBold"
  | "TextItalic"
  | "TextUnderline"
  | "ThumbDown"
  | "ThumbUp"
  | "Ticket"
  | "Traffic"
  | "Trailer"
  | "Trash"
  | "Tree"
  | "Truck"
  | "Unassign"
  | "Unassigned"
  | "Unavailable"
  | "UndoArrow"
  | "Undo"
  | "Unuser"
  | "Upload"
  | "UserFill"
  | "User"
  | "Users"
  | "VerificationCode"
  | "Walking"
  | "WarehouseFill"
  | "Warehouse"
  | "WarningCircleNotFilled"
  | "WarningCircle"
  | "WarningNotFilled"
  | "Warning"
  | "Weight"
  | "Wheel"
  | "ZoomIn"
  | "ZoomOut";

export enum BringgFontIcons {
  Accelerate = "accelerate",
  AddLocationAlt = "add-location-alt",
  Ai = "ai",
  AltRoute = "alt-route",
  AnalyticsChart = "analytics-chart",
  Analytics = "analytics",
  AreaChart = "area-chart",
  ArrowDown = "arrow-down",
  ArrowLeft = "arrow-left",
  ArrowRight = "arrow-right",
  ArrowUp = "arrow-up",
  Arrow = "arrow",
  ArrowsUpDown = "arrows-up-down",
  Attachment = "attachment",
  AutoStories = "auto-stories",
  Autopay = "autopay",
  Barcode = "barcode",
  BarsFilter = "bars-filter",
  BatteryFull = "battery-full",
  BatteryVerEmpty = "battery-ver-empty",
  BatteryVerHalf = "battery-ver-half",
  BatteryVerQuarter = "battery-ver-quarter",
  BatteryVerThreeQuarters = "battery-ver-three-quarters",
  Bicycle = "bicycle",
  Block = "block",
  BreakTo = "break-to",
  Bringg = "bringg",
  Bullseye = "bullseye",
  Bus = "bus",
  Business = "business",
  Busket = "busket",
  CafeSolid = "cafe-solid",
  Cafe = "cafe",
  Calendar = "calendar",
  Campaign = "campaign",
  Cancel = "cancel",
  Cancelled = "cancelled",
  Capacity = "capacity",
  Car = "car",
  Cart = "cart",
  Cashier = "cashier",
  ChatBubble = "chat-bubble",
  ChatBubbles = "chat-bubbles",
  Checklist = "checklist",
  ChevronLeft = "chevron-left",
  ChevronRight = "chevron-right",
  ChevronUp = "chevron-up",
  Chevron = "chevron",
  ChevronsEnd = "chevrons-end",
  ChevronsStart = "chevrons-start",
  CircleExclamation = "circle-exclamation",
  CirclePlus = "circle-plus",
  Circle = "circle",
  ClockLight = "clock-light",
  Clock = "clock",
  CloseCircle = "close-circle",
  Close = "close",
  Coins = "coins",
  Colorize = "colorize",
  Columns = "columns",
  Compare = "compare",
  Compass = "compass",
  Completed = "completed",
  ConnectedHub = "connected-hub",
  ControlTower = "control-tower",
  Copy = "copy",
  CreateRoutePlus = "create-route-plus",
  CreateRoute = "create-route",
  CreditCard = "credit-card",
  Crew = "crew",
  CsvFile = "csv-file",
  Cube = "cube",
  CustomerSdk = "customer-sdk",
  Customer = "customer",
  Cutoff = "cutoff",
  DeliveryBlocks = "delivery-blocks",
  DeliverySlots = "delivery-slots",
  DeployedCodeHistory = "deployed-code-history",
  DesignServices = "design-services",
  Dispatch = "dispatch",
  Dispatchers = "dispatchers",
  Distance = "distance",
  DistributionHub = "distribution-hub",
  DocumenatationLink = "documenatation-link",
  Document = "document",
  DonePlanning = "done-planning",
  Dot = "dot",
  Download = "download",
  Drag = "drag",
  DriverHome = "driver-home",
  DriversReturningToBase = "drivers-returning-to-base",
  Drivers = "drivers",
  Dropoff = "dropoff",
  Eco = "eco",
  EditSquare = "edit-square",
  Erase = "erase",
  EventAvailable = "event-available",
  Expenses = "expenses",
  Export = "export",
  ExternalId = "external-id",
  ExternalLink = "external-link",
  EyeOff = "eye-off",
  Eye = "eye",
  Feather = "feather",
  FileAlt = "file-alt",
  FileImport = "file-import",
  File = "file",
  FilterHdr = "filter-hdr",
  FilterList = "filter-list",
  FlatTire = "flat-tire",
  FloatingInventory = "floating-inventory",
  ForkLeftRightBack = "fork-left-right-back",
  Forward = "forward",
  Fragile = "fragile",
  Freeze = "freeze",
  Functions = "functions",
  Globe = "globe",
  GoToLink = "go-to-link",
  GraphOverview = "graph-overview",
  Graph = "graph",
  GroupBy = "group-by",
  Hamburger = "hamburger",
  HandPanMove = "hand-pan-move",
  HandPointingUp = "hand-pointing-up",
  Headset = "headset",
  HeartFilled = "heart-filled",
  Heart = "heart",
  Help = "help",
  Home = "home",
  Hourglass = "hourglass",
  Hub = "hub",
  InfoFilled = "info-filled",
  Info = "info",
  Inventory = "inventory",
  Json = "json",
  Keyboard = "keyboard",
  Launch = "launch",
  LayersFill = "layers-fill",
  Layers = "layers",
  LeafEco = "leaf-eco",
  LibraryBooks = "library-books",
  Link = "link",
  List = "list",
  Loader = "loader",
  LocalPolice = "local-police",
  LocalShipping = "local-shipping",
  LocationFill = "location-fill",
  Location = "location",
  Lock = "lock",
  Locker = "locker",
  Logout = "logout",
  Man = "man",
  ManageHistory = "manage-history",
  MapTask = "map-task",
  Map = "map",
  Maximize = "maximize",
  MenuHorizontal = "menu-horizontal",
  Menu = "menu",
  MessageMail = "message-mail",
  Minimize = "minimize",
  Minus = "minus",
  MobileActionCompleteForm = "mobile-action-complete-form",
  MobileActionQuestion = "mobile-action-question",
  Monitor = "monitor",
  MoveToDispatch = "move-to-dispatch",
  MoveToPlanning = "move-to-planning",
  MyLocation = "my-location",
  NavigationUp = "navigation-up",
  Navigation = "navigation",
  NoLocation = "no-location",
  NoVehicle = "no-vehicle",
  NoteLight = "note-light",
  Notes = "notes",
  Notification = "notification",
  OpenInNew = "open-in-new",
  Optimize = "optimize",
  Order = "order",
  OrderedList = "ordered-list",
  Orders = "orders",
  Package = "package",
  Pallets = "pallets",
  ParkingLocation = "parking-location",
  Parking = "parking",
  PartnerExchange = "partner-exchange",
  Pause = "pause",
  PdfFile = "pdf-file",
  Pencil = "pencil",
  PhoneAndroid = "phone-android",
  Phone = "phone",
  Pickup = "pickup",
  Planning = "planning",
  Play = "play",
  Plus = "plus",
  Power = "power",
  Preferences = "preferences",
  PreparationRestaurant = "preparation-restaurant",
  Preperation = "preperation",
  Print = "print",
  PrompedMessage = "promped-message",
  Puzzle = "puzzle",
  Radar = "radar",
  Recipt = "recipt",
  RedoArrow = "redo-arrow",
  Redo = "redo",
  Reload = "reload",
  Report = "report",
  Reschedule = "reschedule",
  Resources = "resources",
  Revenues = "revenues",
  Reviews = "reviews",
  RoSimulator = "ro-simulator",
  Rotate = "rotate",
  RouteIdentifier = "route-identifier",
  Route = "route",
  Ruler = "ruler",
  Satellite = "satellite",
  SaveAs = "save-as",
  Save = "save",
  Scanner = "scanner",
  Search = "search",
  SelectedOutline = "selected-outline",
  Selected = "selected",
  Send = "send",
  ServiceAreas = "service-areas",
  SettingsSuggest = "settings-suggest",
  Settings = "settings",
  Share = "share",
  SheetWithDollar = "sheet-with-dollar",
  ShieldPerson = "shield-person",
  ShowLess = "show-less",
  ShowMore = "show-more",
  Skills = "skills",
  SmallCircle = "small-circle",
  SortAsc = "sort-asc",
  SortDesc = "sort-desc",
  Sparkles = "sparkles",
  Star = "star",
  StickyNote = "sticky-note",
  StopCircle = "stop-circle",
  Store = "store",
  Suffix = "suffix",
  Suitcase = "suitcase",
  Support = "support",
  TakeoutDining = "takeout-dining",
  TaskAlt = "task-alt",
  TeamHome = "team-home",
  TeamParking = "team-parking",
  Team = "team",
  TextBold = "text-bold",
  TextItalic = "text-italic",
  TextUnderline = "text-underline",
  ThumbDown = "thumb-down",
  ThumbUp = "thumb-up",
  Ticket = "ticket",
  Traffic = "traffic",
  Trailer = "trailer",
  Trash = "trash",
  Tree = "tree",
  Truck = "truck",
  Unassign = "unassign",
  Unassigned = "unassigned",
  Unavailable = "unavailable",
  UndoArrow = "undo-arrow",
  Undo = "undo",
  Unuser = "unuser",
  Upload = "upload",
  UserFill = "user-fill",
  User = "user",
  Users = "users",
  VerificationCode = "verification-code",
  Walking = "walking",
  WarehouseFill = "warehouse-fill",
  Warehouse = "warehouse",
  WarningCircleNotFilled = "warning-circle-not-filled",
  WarningCircle = "warning-circle",
  WarningNotFilled = "warning-not-filled",
  Warning = "warning",
  Weight = "weight",
  Wheel = "wheel",
  ZoomIn = "zoom-in",
  ZoomOut = "zoom-out",
}

export const BRINGG_FONT_ICONS_CODEPOINTS: { [key in BringgFontIcons]: string } = {
  [BringgFontIcons.Accelerate]: "61697",
  [BringgFontIcons.AddLocationAlt]: "61698",
  [BringgFontIcons.Ai]: "61699",
  [BringgFontIcons.AltRoute]: "61700",
  [BringgFontIcons.AnalyticsChart]: "61701",
  [BringgFontIcons.Analytics]: "61702",
  [BringgFontIcons.AreaChart]: "61703",
  [BringgFontIcons.ArrowDown]: "61704",
  [BringgFontIcons.ArrowLeft]: "61705",
  [BringgFontIcons.ArrowRight]: "61706",
  [BringgFontIcons.ArrowUp]: "61707",
  [BringgFontIcons.Arrow]: "61708",
  [BringgFontIcons.ArrowsUpDown]: "61709",
  [BringgFontIcons.Attachment]: "61710",
  [BringgFontIcons.AutoStories]: "61711",
  [BringgFontIcons.Autopay]: "61712",
  [BringgFontIcons.Barcode]: "61713",
  [BringgFontIcons.BarsFilter]: "61714",
  [BringgFontIcons.BatteryFull]: "61715",
  [BringgFontIcons.BatteryVerEmpty]: "61716",
  [BringgFontIcons.BatteryVerHalf]: "61717",
  [BringgFontIcons.BatteryVerQuarter]: "61718",
  [BringgFontIcons.BatteryVerThreeQuarters]: "61719",
  [BringgFontIcons.Bicycle]: "61720",
  [BringgFontIcons.Block]: "61721",
  [BringgFontIcons.BreakTo]: "61722",
  [BringgFontIcons.Bringg]: "61723",
  [BringgFontIcons.Bullseye]: "61724",
  [BringgFontIcons.Bus]: "61725",
  [BringgFontIcons.Business]: "61726",
  [BringgFontIcons.Busket]: "61727",
  [BringgFontIcons.CafeSolid]: "61728",
  [BringgFontIcons.Cafe]: "61729",
  [BringgFontIcons.Calendar]: "61730",
  [BringgFontIcons.Campaign]: "61731",
  [BringgFontIcons.Cancel]: "61732",
  [BringgFontIcons.Cancelled]: "61733",
  [BringgFontIcons.Capacity]: "61734",
  [BringgFontIcons.Car]: "61735",
  [BringgFontIcons.Cart]: "61736",
  [BringgFontIcons.Cashier]: "61737",
  [BringgFontIcons.ChatBubble]: "61738",
  [BringgFontIcons.ChatBubbles]: "61739",
  [BringgFontIcons.Checklist]: "61740",
  [BringgFontIcons.ChevronLeft]: "61741",
  [BringgFontIcons.ChevronRight]: "61742",
  [BringgFontIcons.ChevronUp]: "61743",
  [BringgFontIcons.Chevron]: "61744",
  [BringgFontIcons.ChevronsEnd]: "61745",
  [BringgFontIcons.ChevronsStart]: "61746",
  [BringgFontIcons.CircleExclamation]: "61747",
  [BringgFontIcons.CirclePlus]: "61748",
  [BringgFontIcons.Circle]: "61749",
  [BringgFontIcons.ClockLight]: "61750",
  [BringgFontIcons.Clock]: "61751",
  [BringgFontIcons.CloseCircle]: "61752",
  [BringgFontIcons.Close]: "61753",
  [BringgFontIcons.Coins]: "61754",
  [BringgFontIcons.Colorize]: "61755",
  [BringgFontIcons.Columns]: "61756",
  [BringgFontIcons.Compare]: "61757",
  [BringgFontIcons.Compass]: "61758",
  [BringgFontIcons.Completed]: "61759",
  [BringgFontIcons.ConnectedHub]: "61760",
  [BringgFontIcons.ControlTower]: "61761",
  [BringgFontIcons.Copy]: "61762",
  [BringgFontIcons.CreateRoutePlus]: "61763",
  [BringgFontIcons.CreateRoute]: "61764",
  [BringgFontIcons.CreditCard]: "61765",
  [BringgFontIcons.Crew]: "61766",
  [BringgFontIcons.CsvFile]: "61767",
  [BringgFontIcons.Cube]: "61768",
  [BringgFontIcons.CustomerSdk]: "61769",
  [BringgFontIcons.Customer]: "61770",
  [BringgFontIcons.Cutoff]: "61771",
  [BringgFontIcons.DeliveryBlocks]: "61772",
  [BringgFontIcons.DeliverySlots]: "61773",
  [BringgFontIcons.DeployedCodeHistory]: "61774",
  [BringgFontIcons.DesignServices]: "61775",
  [BringgFontIcons.Dispatch]: "61776",
  [BringgFontIcons.Dispatchers]: "61777",
  [BringgFontIcons.Distance]: "61778",
  [BringgFontIcons.DistributionHub]: "61779",
  [BringgFontIcons.DocumenatationLink]: "61780",
  [BringgFontIcons.Document]: "61781",
  [BringgFontIcons.DonePlanning]: "61782",
  [BringgFontIcons.Dot]: "61783",
  [BringgFontIcons.Download]: "61784",
  [BringgFontIcons.Drag]: "61785",
  [BringgFontIcons.DriverHome]: "61786",
  [BringgFontIcons.DriversReturningToBase]: "61787",
  [BringgFontIcons.Drivers]: "61788",
  [BringgFontIcons.Dropoff]: "61789",
  [BringgFontIcons.Eco]: "61790",
  [BringgFontIcons.EditSquare]: "61791",
  [BringgFontIcons.Erase]: "61792",
  [BringgFontIcons.EventAvailable]: "61793",
  [BringgFontIcons.Expenses]: "61794",
  [BringgFontIcons.Export]: "61795",
  [BringgFontIcons.ExternalId]: "61796",
  [BringgFontIcons.ExternalLink]: "61797",
  [BringgFontIcons.EyeOff]: "61798",
  [BringgFontIcons.Eye]: "61799",
  [BringgFontIcons.Feather]: "61800",
  [BringgFontIcons.FileAlt]: "61801",
  [BringgFontIcons.FileImport]: "61802",
  [BringgFontIcons.File]: "61803",
  [BringgFontIcons.FilterHdr]: "61804",
  [BringgFontIcons.FilterList]: "61805",
  [BringgFontIcons.FlatTire]: "61806",
  [BringgFontIcons.FloatingInventory]: "61807",
  [BringgFontIcons.ForkLeftRightBack]: "61808",
  [BringgFontIcons.Forward]: "61809",
  [BringgFontIcons.Fragile]: "61810",
  [BringgFontIcons.Freeze]: "61811",
  [BringgFontIcons.Functions]: "61812",
  [BringgFontIcons.Globe]: "61813",
  [BringgFontIcons.GoToLink]: "61814",
  [BringgFontIcons.GraphOverview]: "61815",
  [BringgFontIcons.Graph]: "61816",
  [BringgFontIcons.GroupBy]: "61817",
  [BringgFontIcons.Hamburger]: "61818",
  [BringgFontIcons.HandPanMove]: "61819",
  [BringgFontIcons.HandPointingUp]: "61820",
  [BringgFontIcons.Headset]: "61821",
  [BringgFontIcons.HeartFilled]: "61822",
  [BringgFontIcons.Heart]: "61823",
  [BringgFontIcons.Help]: "61824",
  [BringgFontIcons.Home]: "61825",
  [BringgFontIcons.Hourglass]: "61826",
  [BringgFontIcons.Hub]: "61827",
  [BringgFontIcons.InfoFilled]: "61828",
  [BringgFontIcons.Info]: "61829",
  [BringgFontIcons.Inventory]: "61830",
  [BringgFontIcons.Json]: "61831",
  [BringgFontIcons.Keyboard]: "61832",
  [BringgFontIcons.Launch]: "61833",
  [BringgFontIcons.LayersFill]: "61834",
  [BringgFontIcons.Layers]: "61835",
  [BringgFontIcons.LeafEco]: "61836",
  [BringgFontIcons.LibraryBooks]: "61837",
  [BringgFontIcons.Link]: "61838",
  [BringgFontIcons.List]: "61839",
  [BringgFontIcons.Loader]: "61840",
  [BringgFontIcons.LocalPolice]: "61841",
  [BringgFontIcons.LocalShipping]: "61842",
  [BringgFontIcons.LocationFill]: "61843",
  [BringgFontIcons.Location]: "61844",
  [BringgFontIcons.Lock]: "61845",
  [BringgFontIcons.Locker]: "61846",
  [BringgFontIcons.Logout]: "61847",
  [BringgFontIcons.Man]: "61848",
  [BringgFontIcons.ManageHistory]: "61849",
  [BringgFontIcons.MapTask]: "61850",
  [BringgFontIcons.Map]: "61851",
  [BringgFontIcons.Maximize]: "61852",
  [BringgFontIcons.MenuHorizontal]: "61853",
  [BringgFontIcons.Menu]: "61854",
  [BringgFontIcons.MessageMail]: "61855",
  [BringgFontIcons.Minimize]: "61856",
  [BringgFontIcons.Minus]: "61857",
  [BringgFontIcons.MobileActionCompleteForm]: "61858",
  [BringgFontIcons.MobileActionQuestion]: "61859",
  [BringgFontIcons.Monitor]: "61860",
  [BringgFontIcons.MoveToDispatch]: "61861",
  [BringgFontIcons.MoveToPlanning]: "61862",
  [BringgFontIcons.MyLocation]: "61863",
  [BringgFontIcons.NavigationUp]: "61864",
  [BringgFontIcons.Navigation]: "61865",
  [BringgFontIcons.NoLocation]: "61866",
  [BringgFontIcons.NoVehicle]: "61867",
  [BringgFontIcons.NoteLight]: "61868",
  [BringgFontIcons.Notes]: "61869",
  [BringgFontIcons.Notification]: "61870",
  [BringgFontIcons.OpenInNew]: "61871",
  [BringgFontIcons.Optimize]: "61872",
  [BringgFontIcons.Order]: "61873",
  [BringgFontIcons.OrderedList]: "61874",
  [BringgFontIcons.Orders]: "61875",
  [BringgFontIcons.Package]: "61876",
  [BringgFontIcons.Pallets]: "61877",
  [BringgFontIcons.ParkingLocation]: "61878",
  [BringgFontIcons.Parking]: "61879",
  [BringgFontIcons.PartnerExchange]: "61880",
  [BringgFontIcons.Pause]: "61881",
  [BringgFontIcons.PdfFile]: "61882",
  [BringgFontIcons.Pencil]: "61883",
  [BringgFontIcons.PhoneAndroid]: "61884",
  [BringgFontIcons.Phone]: "61885",
  [BringgFontIcons.Pickup]: "61886",
  [BringgFontIcons.Planning]: "61887",
  [BringgFontIcons.Play]: "61888",
  [BringgFontIcons.Plus]: "61889",
  [BringgFontIcons.Power]: "61890",
  [BringgFontIcons.Preferences]: "61891",
  [BringgFontIcons.PreparationRestaurant]: "61892",
  [BringgFontIcons.Preperation]: "61893",
  [BringgFontIcons.Print]: "61894",
  [BringgFontIcons.PrompedMessage]: "61895",
  [BringgFontIcons.Puzzle]: "61896",
  [BringgFontIcons.Radar]: "61897",
  [BringgFontIcons.Recipt]: "61898",
  [BringgFontIcons.RedoArrow]: "61899",
  [BringgFontIcons.Redo]: "61900",
  [BringgFontIcons.Reload]: "61901",
  [BringgFontIcons.Report]: "61902",
  [BringgFontIcons.Reschedule]: "61903",
  [BringgFontIcons.Resources]: "61904",
  [BringgFontIcons.Revenues]: "61905",
  [BringgFontIcons.Reviews]: "61906",
  [BringgFontIcons.RoSimulator]: "61907",
  [BringgFontIcons.Rotate]: "61908",
  [BringgFontIcons.RouteIdentifier]: "61909",
  [BringgFontIcons.Route]: "61910",
  [BringgFontIcons.Ruler]: "61911",
  [BringgFontIcons.Satellite]: "61912",
  [BringgFontIcons.SaveAs]: "61913",
  [BringgFontIcons.Save]: "61914",
  [BringgFontIcons.Scanner]: "61915",
  [BringgFontIcons.Search]: "61916",
  [BringgFontIcons.SelectedOutline]: "61917",
  [BringgFontIcons.Selected]: "61918",
  [BringgFontIcons.Send]: "61919",
  [BringgFontIcons.ServiceAreas]: "61920",
  [BringgFontIcons.SettingsSuggest]: "61921",
  [BringgFontIcons.Settings]: "61922",
  [BringgFontIcons.Share]: "61923",
  [BringgFontIcons.SheetWithDollar]: "61924",
  [BringgFontIcons.ShieldPerson]: "61925",
  [BringgFontIcons.ShowLess]: "61926",
  [BringgFontIcons.ShowMore]: "61927",
  [BringgFontIcons.Skills]: "61928",
  [BringgFontIcons.SmallCircle]: "61929",
  [BringgFontIcons.SortAsc]: "61930",
  [BringgFontIcons.SortDesc]: "61931",
  [BringgFontIcons.Sparkles]: "61932",
  [BringgFontIcons.Star]: "61933",
  [BringgFontIcons.StickyNote]: "61934",
  [BringgFontIcons.StopCircle]: "61935",
  [BringgFontIcons.Store]: "61936",
  [BringgFontIcons.Suffix]: "61937",
  [BringgFontIcons.Suitcase]: "61938",
  [BringgFontIcons.Support]: "61939",
  [BringgFontIcons.TakeoutDining]: "61940",
  [BringgFontIcons.TaskAlt]: "61941",
  [BringgFontIcons.TeamHome]: "61942",
  [BringgFontIcons.TeamParking]: "61943",
  [BringgFontIcons.Team]: "61944",
  [BringgFontIcons.TextBold]: "61945",
  [BringgFontIcons.TextItalic]: "61946",
  [BringgFontIcons.TextUnderline]: "61947",
  [BringgFontIcons.ThumbDown]: "61948",
  [BringgFontIcons.ThumbUp]: "61949",
  [BringgFontIcons.Ticket]: "61950",
  [BringgFontIcons.Traffic]: "61951",
  [BringgFontIcons.Trailer]: "61952",
  [BringgFontIcons.Trash]: "61953",
  [BringgFontIcons.Tree]: "61954",
  [BringgFontIcons.Truck]: "61955",
  [BringgFontIcons.Unassign]: "61956",
  [BringgFontIcons.Unassigned]: "61957",
  [BringgFontIcons.Unavailable]: "61958",
  [BringgFontIcons.UndoArrow]: "61959",
  [BringgFontIcons.Undo]: "61960",
  [BringgFontIcons.Unuser]: "61961",
  [BringgFontIcons.Upload]: "61962",
  [BringgFontIcons.UserFill]: "61963",
  [BringgFontIcons.User]: "61964",
  [BringgFontIcons.Users]: "61965",
  [BringgFontIcons.VerificationCode]: "61966",
  [BringgFontIcons.Walking]: "61967",
  [BringgFontIcons.WarehouseFill]: "61968",
  [BringgFontIcons.Warehouse]: "61969",
  [BringgFontIcons.WarningCircleNotFilled]: "61970",
  [BringgFontIcons.WarningCircle]: "61971",
  [BringgFontIcons.WarningNotFilled]: "61972",
  [BringgFontIcons.Warning]: "61973",
  [BringgFontIcons.Weight]: "61974",
  [BringgFontIcons.Wheel]: "61975",
  [BringgFontIcons.ZoomIn]: "61976",
  [BringgFontIcons.ZoomOut]: "61977",
};
